import styled from "styled-components"
import { useDeleteLogic } from "./delete.logic"
import { Header } from "../components/Header"
import { ErrorMessage } from "../components/ErrorMessage"
import { Button } from "../components/Button"
import { InformationMessage } from "../components/InformationMessage"

const Input = styled.input`
    display: block;
    margin: 10px auto;
    width: 250px;
    font-size: 16px;
    text-align: center;
    padding: 5px;
    border-radius: 4px;
    border: 1px solid black;
    padding: 7px;
`

export const DeletePage = () => {

    const { setLocationField, errorMessage, data, removePalletLocation, showData } = useDeleteLogic();

    return (
        <>
            <Header title={"ZDEJMIJ"} subtitle={"PALETE"} />
            <Input name='location' onChange={(e) => setLocationField(e.target.value)} placeholder="Lokalizacja np. D-02-09-1/3" />
            <Button onClick={() => removePalletLocation()} text="Zdejmij palete"/>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <InformationMessage>Podaj lokalizację palety, która ma zostać usunięta z regału.</InformationMessage>
            {data && showData()}
        </>
    )
}